import { observable, action } from 'mobx'
import Api from '@api/xi_feng/case'

class Store {
  id

  @observable info = {}

  @action
  getInfo = async () => {
    const { success, data } = await Api.getInfo({ sample_id: this.id })
    if (success) {
      this.info = data
    }
  }

  @action
  addRelation = async (data, callback) => {
    const { success } = await Api.addRelation({
      sample_id: this.id,
      work_ids: data.join(',')
    })

    if (success) {
      callback && callback()
    }
  }
}

export default Store
